// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30kar","top":"styles_top__3r-_R","left":"styles_left__1dmib","description":"styles_description__1PINJ"};